import { IEstimationChartState } from '../../types/redux/estimationChart';
import { TReduxActions } from '../../types/redux';
import { EActionTypes } from '../../actions/estimationChart';

export const initialState: IEstimationChartState = {
  isError: false,
  isFetching: false,
  data: null,
};

export const estimationChartReducer = (state = initialState, action: TReduxActions): IEstimationChartState => {
  switch (action.type) {
    case EActionTypes.Request: {
      return {
        ...state,
        isFetching: true,
      };
    }

    case EActionTypes.Success: {
      return {
        ...state,
        isFetching: false,
        isError: false,
        data: action.payload,
      };
    }

    case EActionTypes.Failure: {
      return {
        ...state,
        isFetching: false,
        isError: true,
      };
    }

    default:
      return state;
  }
};
